const RELOAD_KEY = "atlas:module-load-reload";
const RELOAD_COOLDOWN_MS = 60_000;

/** Browser fetch failures only; module evaluation and application errors stay errors. */
export function isModuleLoadError(error: unknown): error is Error {
  return error instanceof Error && (
    error.message.startsWith("Failed to fetch dynamically imported module") ||
    error.message.startsWith("error loading dynamically imported module") ||
    error.message.startsWith("Importing a module script failed") ||
    error.message.startsWith("Unable to preload CSS for ")
  );
}

/** Refresh obsolete chunks once; retain a safe reason when recovery is blocked. */
export function recoverFromModuleLoadError(error: unknown) {
  if (!isModuleLoadError(error)) return "not_module_error";
  if (typeof window === "undefined") return "server";
  if (window.navigator.onLine === false) return "offline";

  try {
    const now = Date.now();
    const previous = window.sessionStorage.getItem(RELOAD_KEY);
    // A future timestamp also blocks retries if the device clock moves back.
    if (previous !== null && now - Number(previous) < RELOAD_COOLDOWN_MS) return "cooldown";
    window.sessionStorage.setItem(RELOAD_KEY, String(now));
    window.location.reload();
    return "reloading";
  } catch {
    // If storage is unavailable, retain the manual retry rather than risk a loop.
    return "storage_unavailable";
  }
}
